import {round} from 'lodash'

export const useShortScale = () => {
  const convertValueToShortScale = (value: any) => {
    if (value < 1000) {
      return round(value, 1)
    } else if (value < 1000000) {
      return round(value / 1000, 1) + 'K'
    } else if (value < 1000000000) {
      return round(value / 1000000, 1) + 'M'
    } else {
      return round(value / 1000000000, 1) + 'B'
    }
  }

  return {convertValueToShortScale}
}
